import types from '../actionTypes';
import axios from 'axios'
import { apiEndpoint } from '../../settings';

export const openFilterModule = () => ({ type: types.OPEN_FILTER });
export const toggleFilterSections = section => ({ type: types.TOGGLE_FILTER_SECTIONS, section });
export const collapseFilterSections = () => ({ type: types.COLLAPSE_FILTER_SECTIONS });
export const setFilterSectionsLoading = (section, status) => ({ type: types.SET_FILTER_SECTIONS_LOADING, section, status });


export const resetFilterTopics = () => ({ type: types.GET_FILTER_TOPICS, payload: [] });


export const setFilterLevel = levelID => ({ type: types.SET_FILTER_LEVEL, levelID });
export const setFilterClass = classID => ({ type: types.SET_FILTER_CLASS, classID });
export const setFilterSubject = subjectID => ({ type: types.SET_FILTER_SUBJECT, subjectID });
export const setFilterTopic = topicID => ({ type: types.SET_FILTER_TOPIC, topicID });
export const setFilterTaskType = taskTypeID => ({ type: types.SET_FILTER_TASKTYPE, taskTypeID });
export const setFilterDifficulty = difficultyID => ({ type: types.SET_FILTER_DIFFICULTY, difficultyID });
export const setFilters = (filters) => {
    return dispatch => {
        dispatch({ type: types.SET_ALL_FILTERS, filters });
    }
};

export const resetFilterSelectedClasses = () => ({ type: types.RESET_FILTER_CLASSES });
export const resetFilterSelectedSubjects = () => ({ type: types.RESET_FILTER_SUBJECTS });
export const resetFilterSelectedTopics = () => ({ type: types.RESET_FILTER_TOPICS });
export const resetFilterSelectedTaskType = () => ({ type: types.RESET_FILTER_TASKTYPE });

export const getFilterLevels = () => {
    return dispatch => {
        let dataFormData = new FormData()
        dataFormData.append('funkcja', 'pobierz_poziomy_kszt');

        axios({
            method: 'post',
            url: apiEndpoint,
            data: dataFormData
        }).then(res => {
            dispatch({ type: types.GET_FILTER_LEVELS, payload: res.data })
        }).catch(err => {
            console.log(err);
            dispatch({ type: types.GET_FILTER_LEVELS, payload: [] })
            dispatch({ type: types.SET_API_ERROR, state: true });
        })
    }
}

export const getFilterClasses = (levelID) => {
    return dispatch => {
        let dataFormData = new FormData()
        dataFormData.append('funkcja', 'pobierz_klasy');
        dataFormData.append('poziom_id', levelID);

        dispatch(setFilterSectionsLoading('classes', true));

        axios({
            method: 'post',
            url: apiEndpoint,
            data: dataFormData
        }).then(res => {
            dispatch({ type: types.GET_FILTER_CLASSES, payload: res.data });
            dispatch(setFilterSectionsLoading('classes', false));
        }).catch(err => {
            console.log(err);
            dispatch({ type: types.GET_FILTER_CLASSES, payload: [] });
            dispatch(setFilterSectionsLoading('classes', false));
            // dispatch({ type: types.SET_API_ERROR, state: true });
        })
    }
}

export const getFilterSubjects = (levelID, classes) => {
    return dispatch => {
        let dataFormData = new FormData()
        dataFormData.append('funkcja', 'pobierz_przedmioty');
        dataFormData.append('poziom_id', levelID);
        dataFormData.append('klasy', classes);

        dispatch(setFilterSectionsLoading('subjects', true));

        axios({
            method: 'post',
            url: apiEndpoint,
            data: dataFormData
        }).then(res => {
            dispatch({ type: types.GET_FILTER_SUBJECTS, payload: res.data });
            dispatch(setFilterSectionsLoading('subjects', false));
        }).catch(err => {
            console.log(err);
            dispatch({ type: types.GET_FILTER_SUBJECTS, payload: [] });
            dispatch(setFilterSectionsLoading('subjects', false));
            // dispatch({ type: types.SET_API_ERROR, state: true });
        })
    }
}

export const getFilterTopics = (user, level, classes, subjects, taskType) => {
    let dataFormData = new FormData()
    dataFormData.append('funkcja', 'pobierz_liste_pytan');
    dataFormData.append('poziom_kszt_id', level);
    dataFormData.append('klasa_id', classes);
    dataFormData.append('typ_pytania', taskType);
    dataFormData.append('przedmiot_id', subjects);
    dataFormData.append('poziom_dostepu', 0);

    return dispatch => {

        dispatch(setFilterSectionsLoading('topics', true));

        axios({
            method: 'post',
            url: apiEndpoint,
            data: dataFormData
        }).then(res => {
            if (res.data.success) {
                let topics = Object.keys(res.data).filter(key => key !== 'success' && key !== 'reason').map(key => res.data[key]);
                if (user.demo) {
                    topics = topics.filter(topic => user.levels_subjects_topics[level].map(entry => entry.temat).includes(topic.temat_id))
                }
                dispatch({ type: types.GET_FILTER_TOPICS, payload: topics });
                dispatch(setFilterSectionsLoading('topics', false));
            } else {
                // dispatch({ type: types.SET_API_ERROR, state: true });
                dispatch({ type: types.GET_FILTER_TOPICS, payload: [] });
                dispatch(setFilterSectionsLoading('topics', false));
                throw Error(res.data.reason)
            }
        }).catch(err => {
            console.log(err)
            // dispatch({ type: types.SET_API_ERROR, state: true });
        })
    }
};

export const getFilterTaskTypes = () => {
    return dispatch => {
        let dataFormData = new FormData()
        dataFormData.append('funkcja', 'pobierz_typy_pytan');

        axios({
            method: 'post',
            url: apiEndpoint,
            data: dataFormData
        }).then(res => {
            dispatch({ type: types.GET_FILTER_TASKTYPES, payload: res.data })
        }).catch(err => {
            console.log(err);
            dispatch({ type: types.GET_FILTER_TASKTYPES, payload: [] })
            // dispatch({ type: types.SET_API_ERROR, state: true });
        })
    }
}

export const getFilterDifficulties = () => {
    return dispatch => {
        let dataFormData = new FormData()
        dataFormData.append('funkcja', 'get_difficulties');

        axios({
            method: 'post',
            url: apiEndpoint,
            data: dataFormData
        }).then(res => {
            dispatch({ type: types.GET_FILTER_DIFFICULTIES, payload: res.data.difficulties });
        }).catch(err => {
            console.log(err);
            dispatch({ type: types.GET_FILTER_DIFFICULTIES, payload: [] });
            // dispatch({ type: types.SET_API_ERROR, state: true });
        })
    }
}